<div class="Header" [ngClass]="{home: isHome}">
    <div class="headerWrapper">
        <div class="menuButton" *ngIf="isMobile" (click)="onToggleDropdown()">
            <img src="assets/img/menu.png" alt="" class="menu" *ngIf="!isOpen">
            <img src="assets/img/close-white.png" alt="" class="close" *ngIf="isOpen">
        </div>

        <div class="logoWrap">
            <div class="logo">
                <a routerLink="/">
                    <img [src]="!isMobile ?  'assets/img/home/lionsgate-channels-title.png' : 'assets/img/Lionsgate-Channels-top-title.png' "
                        alt="">
                </a>
            </div>
        </div>


        <div class="buttons" *ngIf="!isMobile">
            <a routerLink="/where-to-watch" class="whereToWatchLink">Where To Watch</a>

            <a (click)="onToggleDropdown()" class="channelsButton" [ngClass]="{open: isOpen}">
                <div class="buttonContent">
                    <div class="arrow"></div>
                    <div class="line"></div>
                    <div class="label">
                        Our Channels
                    </div>
                </div>
            </a>
        </div>
    </div>

    <div class="headerOverlay" [ngClass]="{open: isOpen}" (click)="onClose()"></div>

    <div class="headerDropdown" [ngClass]="{open: isOpen, home: isHome}">
        <div class="liveTvHolder">
            <div class="title">
                Free Live TV
            </div>
            <div class="items">
                <span *ngFor="let item of jsonData.liveTv">
                    <a *ngIf="item.external != true" [routerLink]="item.url"  [class]=" 'tvLink ' + item.id"
                        (click)="onClose()">
                        <img [src]="item.logo" alt="">
                    </a>
                    <a *ngIf="item.external == true" [href]="item.url"  [class]=" 'tvLink ' + item.id" target="_blank"
                        (click)="onClose()">
                        <img [src]="item.logo" alt="">
                    </a>
                </span>
            </div>
        </div>

        <div class="seriesHolder">
            <div class="title">
                Series Channels
            </div>
            <div class="items">
                <a [routerLink]="item.url" *ngFor="let item of jsonData.series" [class]=" 'seriesLink ' + item.id"
                    (click)="onClose()">
                    <img [src]="item.logo" alt="">

                    <div class="seriesLinkTitle">
                        {{item.title}}
                    </div>
                </a>
            </div>

            <div *ngIf="isMobile" class="mobileWhereToWatch">
                <a routerLink="/where-to-watch" class="wtwBtn">
                    Where To Watch
                </a>
            </div>
        </div>

    </div>
</div>